var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditQuestions = function SvgEditQuestions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.244 12.41a.833.833 0 0 1 1.248 1.1l-.07.079-1.25 1.25a2.6 2.6 0 0 1-3.678 0 .935.935 0 0 0-1.24-.073l-.082.073-.416.416a.833.833 0 0 1-1.248-1.1l.07-.078.416-.417a2.603 2.603 0 0 1 3.678 0 .935.935 0 0 0 1.24.073l.082-.073zM10.736 1.32a2.084 2.084 0 0 1 3.047 2.837l-.101.11-9.646 9.645c-.12.12-.264.215-.422.278l-.12.041-2.365.673a.833.833 0 0 1-1.05-.942l.02-.089.672-2.365a1.25 1.25 0 0 1 .233-.447l.085-.095zm1.766 1.179a.42.42 0 0 0-.53-.048l-.059.048-9.568 9.568-.234.824.823-.234 9.57-9.57a.417.417 0 0 0 0-.589",
    clipRule: "evenodd"
  })));
};
export default SvgEditQuestions;